import constants from '$$helpers/constants';

class CutArea {
  constructor() {
    this.instance = null;
  }

  init(instance) {
    this.instance = instance;
    this.instance.addTaskLayer({
      renderer: {
        render: task => this.cutAreaRight(task),
        getVisibleRange: instance.getVisibleTasksRange,
      },
    });
    this.instance.addTaskLayer({
      renderer: {
        render: task => this.cutAreaLeft(task),
        getVisibleRange: instance.getVisibleTasksRange,
      },
    });
  }

  cutAreaLeft(task) {
    const timeline = this.instance.$ui.getView('timeline').getScale();
    const scaleStart = timeline.min_date;

    if (task.type !== 'button' && this.instance.config.start_date) {
      const leftCondition = task.start_date.valueOf() < scaleStart.valueOf() && task.end_date.valueOf() > scaleStart.valueOf();

      return leftCondition && this.renderCutArea(task, 'left');
    }
  }

  cutAreaRight(task) {
    const timeline = this.instance.$ui.getView('timeline').getScale();
    const scaleEnd = timeline.max_date;

    if (task.type !== 'button' && this.instance.config.end_date) {
      const rightCondition = task.start_date.valueOf() < scaleEnd.valueOf() && task.end_date.valueOf() > scaleEnd.valueOf();

      return rightCondition && this.renderCutArea(task, 'right');
    }
  }

  renderCutArea(task, side) {
    if (task.$level !== 0) {
      const sizes = this.instance.getTaskPosition(task);
      const filterData = this.instance.ganttDataApi.getCurrentFilter();
      const criticalWay = this.instance.config.highlight_critical_path && this.instance.isCriticalTask(task);
      const colorCutArea = criticalWay && task.type !== 'project' ? '#b51a0a' : constants.COLORS[task.color];

      if (filterData && filterData.properties.rangeDate) {
        if (this.instance.config.start_date && this.instance.config.end_date) {
          const cutArea = document.createElement('div');

          cutArea.innerHTML = `<div style="background-color: ${`${colorCutArea}dd`}"></div>`;
          cutArea.classList.add('cut_areaChart');
          if (task.type === 'project') {
            cutArea.classList.add('cut_areaProject');
          }
          cutArea.classList.add(side);
          cutArea.style.top = `${sizes.top + ((this.instance.config.row_height - 26) / 2)}px`;

          return cutArea;
        }
      }
    }

    return null;
  }
}

export default new CutArea();
